import { useEffect } from 'preact/hooks';

export default function useAutoOpenCustomizer({
  autoOpen,
  assetId,
  defaultConfigId,
}) {
  const deleteSearchParam = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('customizerOpen');
    const newUrl = `${
      window.location.href.split('?')[0]
    }?${searchParams.toString()}`;
    window.history.replaceState({}, '', newUrl);
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('customizerOpen')) {
      if (!autoOpen || !assetId || window.isInited) return deleteSearchParam();

      window.initializeCustomizerPlayer({
        assetId,
        defaultConfigId,
      });
    }

    return null;
  }, [assetId, autoOpen, defaultConfigId]);
}
